import React from "react";
import { useState } from "react";

import { Typography } from "@mui/material";

const TypographySliced = ({ text, size, width }: Props) => {
  const [hover, setHover] = useState(false);

  const onMouseEnter = () => {
    setHover(true);
  };
  const onMouseLeave = () => {
    setHover(false);
  };

  if (!text) return <Typography>-</Typography>;

  if (text.length > size) {
    return (
      <Typography
        style={{
          padding: "2px 0 0 0",
          overflowWrap: "break-word",
          cursor: "pointer",
          inlineSize: width,
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}>
        {hover ? text : text.slice(0, size) + "..."}
      </Typography>
    );
  }
  return <Typography>{text}</Typography>;
};

export interface Props {
  text: string;
  size: number;
  width: string;
}

export default TypographySliced;
